import { render, staticRenderFns } from "./Accueil.vue?vue&type=template&id=6fbeef55&scoped=true&"
import script from "./Accueil.vue?vue&type=script&lang=ts&"
export * from "./Accueil.vue?vue&type=script&lang=ts&"
import style0 from "./Accueil.vue?vue&type=style&index=0&id=6fbeef55&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbeef55",
  null
  
)

export default component.exports